import React from 'react'
import omit from 'lodash/omit'
import Box from '@mui/material/Box'
import Chip from '@mui/material/Chip'
import Paper from '@mui/material/Paper'
import Typography from '@mui/material/Typography'
import { GetReportDetailsFragmentFragment } from 'gqlTypes'

interface Props {
  report: GetReportDetailsFragmentFragment
}
const ReportOverviewTags: React.FC<Props> = ({ report }) => {
  const tags = Object.values(omit(report.tags, '__typename')).flat(1)
  return (
    <Paper sx={{ px: 4, py: 2 }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Tags
      </Typography>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          flexWrap: 'wrap',
          gap: 1,
        }}
      >
        {tags.map((tag, i) => (
          <Chip key={i} label={tag} />
        ))}
      </Box>
    </Paper>
  )
}

export default ReportOverviewTags
